import React, { useEffect, useState } from 'react';
import { v4 as uuidv4 } from 'uuid';
import {
  Box,
  Button,
  Container,
  IconButton,
  Paper,
  TextField,
  Typography,
} from '@mui/material';
import { DataGrid, GridColDef } from '@mui/x-data-grid';
import DeleteIcon from '@mui/icons-material/Delete';

interface GroupData {
  id: string;
  name: string;
}

const GroupList: React.FC = () => {
  const [groupList, setGroupList] = useState<GroupData[]>([]);
  const [newGroupName, setNewGroupName] = useState('');

  useEffect(() => {
    loadGroupList();
  }, []);

  const loadGroupList = () => {
    const saved = localStorage.getItem('group-list');
    if (saved) {
      setGroupList(JSON.parse(saved));
    } else {
      // 初回はDefaultグループを作成
      const defaultGroup: GroupData = { id: uuidv4(), name: 'Default' };
      localStorage.setItem('group-list', JSON.stringify([defaultGroup]));
      setGroupList([defaultGroup]);
    }
  };

  const handleAddGroup = () => {
    if (!newGroupName.trim()) {
      alert('グループ名を入力してください');
      return;
    }

    const newGroup: GroupData = {
      id: uuidv4(),
      name: newGroupName.trim(),
    };

    const updatedList = [...groupList, newGroup];
    localStorage.setItem('group-list', JSON.stringify(updatedList));
    setGroupList(updatedList);
    setNewGroupName('');
  };

  const handleDelete = (id: string) => {
    if (!window.confirm('本当に削除しますか？')) return;

    const updatedList = groupList.filter((group) => group.id !== id);
    localStorage.setItem('group-list', JSON.stringify(updatedList));
    setGroupList(updatedList);
  };

  const columns: GridColDef[] = [
    { field: 'name', headerName: 'グループ名', flex: 1 },
    {
      field: 'actions',
      headerName: '操作',
      sortable: false,
      renderCell: (params) => (
        <IconButton color="error" onClick={() => handleDelete(params.row.id)}>
          <DeleteIcon />
        </IconButton>
      ),
      width: 100,
    },
  ];

  const rows = groupList.map((group) => ({ id: group.id, name: group.name }));

  return (
    <Container maxWidth="sm" sx={{ mt: 4 }}>
      <Paper elevation={3} sx={{ p: 4 }}>
        <Typography variant="h4" component="h1" gutterBottom>
          グループ管理
        </Typography>

        <Box display="flex" gap={2} mb={2}>
          <TextField
            fullWidth
            label="新しいグループ名"
            value={newGroupName}
            onChange={(e) => setNewGroupName(e.target.value)}
          />
          <Button variant="contained" color="primary" onClick={handleAddGroup}>
            追加
          </Button>
        </Box>

        {groupList.length > 0 ? (
          <DataGrid
            rows={rows}
            columns={columns}
            autoHeight
            pageSizeOptions={[5, 10]}
          />
        ) : (
          <Typography variant="body1" color="text.secondary">
            グループがありません。
          </Typography>
        )}
      </Paper>
    </Container>
  );
};

export default GroupList;
